type TbodyProps = {
  className?: string;
  children: React.ReactNode;
}

export default function Tbody({className='', children}: TbodyProps) {
  return (
    <tbody style={{boxShadow: "0 0 0 1px #D3D9DF"}} className={`rounded-lg ${className}`}>{children}</tbody>
  )
}